import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import AddCircleOutlineSharpIcon from "@mui/icons-material/AddCircleOutlineSharp";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import AddOwner from "../../../../../modals/yourAssets/BOA/CustomSubOwnersModal";
import { Typography } from "@mui/material";
import {
  addShareHoldingsInitialValues,
  coShareHoldings,
} from "../../../../../modals/yourAssets/BOA/helper";
import { SecondaryButton } from "../../../../../common/Buttons";
import { addSubOwnersValidationSchemaCOSH as validationSchema } from "../../../../../modals/yourAssets/BOA/helper";

import {
  addUsersCOSH,
  getAllUsersCOSH,
  updateUserCOSH,
} from "../../../../../services/yourAssets/COShareHoldingServices";
import DeleteDataModal from "../../../../../modals/yourAssets/BOA/DeleteDataModal";
import SimpleBarReact from "simplebar-react";

import toast, { Toaster } from "react-hot-toast";
import ImportData from "../ImportData";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { assetStepsNames } from "../../../../../constants/constants";
import { updateAuditTrails } from "../../../../../services/auditTrails";
import ModifiedByToaster from "../../../../../common/ModifiedByToaster";
import {
  getClientIdFromLocalStorage,
  getKeyFromText,
  getDateFromDateStamp,
  getTimeFromDateStamp,
  changeUpdateFormat,
} from "../../../../../utils/Utilities";
import { useDispatch, useSelector } from "react-redux";
import FilePreviewModal from "../../../../yourAssets/BOA/FilePreviewModal";
import DeleteFileModal from "../../../../../modals/yourAssets/BOA/DeleteFileModal";
import { deleteUserMediaBOA } from "../../../../../services/yourAssets/CommonServices";
import { handleReloadFiles } from "../../../../../redux/slices/yourAssets/AssetsDocumentsSlice";
import { getFile } from "../../../../../services/yourAssets/BankBalancesServices";

const Summary = (props) => {
  let clientId = getClientIdFromLocalStorage();
  const { t,i18n } = useTranslation();
  const { id } = useParams();
  const { next } = props;
  const documentList = useSelector(
    (state) => state.assetsDocuments.documents.corporateShareholdings
  );
  const dispatch = useDispatch();
  const [summaryValues, handleSetSummaryValues] = useState([]);
  const [checkChanges, setCheckChanges] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [initialValues, setInitialValues] = useState(null);
  const [deleteDataModal, setDeleteDataModal] = useState(false);
  const [showSubOwnersModal, setShowSubOwnersModal] = useState(false);
  const [userName, setUserName] = useState("");
  const [deleteModalData, setDeleteModalData] = useState({
    object: {},
    mainUser: "",
    subUser: "",
    id: 0,
    index: 0,
  });
  const [updatedIds, setUpdatedIds] = useState([]);
  const [updatesList, setUpdatesList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [focusedDocument, setFocusedDocument] = useState({});
  const [fileStream, setFileStream] = useState("");
  const [fileName, setFileName] = useState("");
  const [deleteDocumentModal, setDeleteDocumentModal] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);

  const getListing = async () => {
    setBtnLoading(true);
    let result = await getAllUsersCOSH(id);
    if (result?.success) {
      let list = result?.payLoad;
      let array = [];
      for (let i = 0; i < list.length; i++) {
        const elementI = list[i];
        let mainObj = {
          nameOfOwner: elementI?.companyName,
          companyName: elementI?.companyName,
          id: elementI?.corporateShareholdingId,
          owner: {
            nameOfOwner: elementI?.nameOfOwner,
            companyName: elementI?.companyName,
            ownerShipPercentage: elementI?.ownerShipPercentage,
            value: elementI?.value,
            information: elementI?.information,
            id: elementI?.corporateShareholdingId,
            subOwners: [],
          },
        };
        for (let j = 0; j < elementI.subCorporateShareholdings.length; j++) {
          const elementJ = elementI.subCorporateShareholdings[j];
          elementJ.id = elementJ.subCorporateShareholdingId;
          elementJ.corporateShareholdingId = elementI.corporateShareholdingId;

          delete elementJ.subCorporateShareholdingId;
        }
        mainObj.owner.subOwners = elementI.subCorporateShareholdings;
        array.push(mainObj);
      }
      handleSetSummaryValues(array);
    }
    setBtnLoading(false);
  };
  const handleUpdates = async (data) => {
    await updateAuditTrails(data, id);
  };
  useEffect(() => {
    setCheckChanges(false);
    getListing();
  }, [checkChanges]);
  useEffect(() => {
    setUpdatedIds(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[6] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[6]?.toLowerCase()
        )
        .map((item) => item?.keyValues?.ObjectId)
    );
    handleUpdates(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[6] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[6]?.toLowerCase()
        )
        .map((item) => item?.auditTrailId)
    );
    setUpdatesList(
      props.updates
        .filter(
          (item) =>
            item.objectName === assetStepsNames[6] ||
            item?.objectName?.toLowerCase() ===
              "sub" + assetStepsNames[6]?.toLowerCase()
        )
        .map((item) => item)
    );
  }, []);
  const handleMainSubmit = async () => {
    setBtnLoading(true);
    let array = [];
    const summaryValuesClone = JSON.parse(JSON.stringify(summaryValues));

    for (let i = 0; i < summaryValuesClone.length; i++) {
      const elementI = summaryValuesClone[i];
      let mainObj = {
        corporateShareholdingId: elementI.id?.length > 10 ? elementI.id : "",
        companyName: elementI.nameOfOwner,
        nameOfOwner: elementI.owner.nameOfOwner,
        ownerShipPercentage: elementI.owner.ownerShipPercentage,
        information: elementI.owner.information,
        value: elementI.owner.value,
        subCorporateShareholdings: [],
      };
      for (let index = 0; index < elementI.owner.subOwners?.length; index++) {
        const elementJ = elementI.owner.subOwners[index];
        elementJ.subCorporateShareholdingId =
          elementJ.id?.length > 10 ? elementJ.id : "";
        elementJ.corporateShareholdingId =
          elementI?.id?.length > 10 ? elementI?.id : "";
        delete elementJ.id;
      }
      mainObj.subCorporateShareholdings = elementI.owner.subOwners;
      array.push(mainObj);
    }
    let result = await updateUserCOSH(array, id);
    if (result?.success) {
      setCheckChanges(true);
      next();
    } else {
      toast.error(t(getKeyFromText(result?.message)));
    }
    setBtnLoading(false);
  };

  const handleAddOwner = (values) => {
    if (selectedRow?.type === "owner") {
      if (selectedRow.behaviour === "create") {
        const { companyName } = values;
        delete values.companyName;
        handleSetSummaryValues([
          ...summaryValues,
          {
            nameOfOwner: companyName,
            id: summaryValues.length + 1,
            owner: { ...values, id: summaryValues.length + 1 },
          },
        ]);
      } else {
        const { companyName } = values;
        delete values.companyName;
        handleSetSummaryValues(
          summaryValues?.map((item, index) => {
            if (item.id === selectedRow.id) {
              return {
                ...item,
                nameOfOwner: companyName,
                owner: {
                  ...item.owner,
                  ...values,
                  id: item.id,
                },
              };
            }
            return { ...item };
          })
        );
      }
    } else {
      if (selectedRow.behaviour === "create") {
        handleSetSummaryValues(
          summaryValues?.map((item, index) => {
            if (item.id === selectedRow.id)
              return {
                ...item,
                owner: {
                  ...item.owner,
                  subOwners: item.owner?.subOwners
                    ? [
                        ...item.owner.subOwners,
                        {
                          ...values,
                          id:
                            item.owner?.subOwners?.length === 0
                              ? 1
                              : item.owner?.subOwners?.length + 1,
                        },
                      ]
                    : [
                        {
                          ...values,
                          id:
                            item.owner?.subOwners?.length === 0
                              ? 1
                              : item.owner?.subOwners?.length + 1,
                        },
                      ],
                },
              };
            return { ...item };
          }) || []
        );
      } else {
        handleSetSummaryValues(
          summaryValues?.map((item, index) => {
            if (item.id === selectedRow.id)
              return {
                ...item,
                owner: {
                  ...item.owner,
                  subOwners: item?.owner?.subOwners?.map((subowner, index) => {
                    if (initialValues.id === subowner.id) {
                      return { ...values, id: subowner?.id };
                    }
                    return subowner;
                  }),
                },
              };
            return { ...item };
          }) || []
        );
      }
    }
  };

  const handleSubOwnersModalOpen = () => {
    setShowSubOwnersModal(true);
  };

  const handleSubOwnersModalClose = () => {
    setSelectedRow(null);
    setShowSubOwnersModal(false);
  };
  const handleSetSelectedRow = (item, type, behaviour = "create") => {
    setSelectedRow({ ...item, type, behaviour });
  };
  const getInitialValues = () => {
    if (initialValues !== null) {
      return {
        companyName: initialValues.companyName ? initialValues.companyName : "",
        nameOfOwner: initialValues.nameOfOwner,
        ownerShipPercentage: initialValues.ownerShipPercentage,
        value: initialValues.value,
        information: initialValues.information,
      };
    }
    return addShareHoldingsInitialValues;
  };

  const handleDeleteOwner = (type, id, index) => {
    if (type === "owner") {
      handleSetSummaryValues(
        summaryValues.filter((item, itemIndex) => itemIndex !== index)
      );
      summaryValues.forEach((item, itemIndex) => {
        if (itemIndex === index)
          return {
            nameOfOwner: item.companyName,
            id: item.id,
          };
        return item;
      });
    } else {
      handleSetSummaryValues(
        summaryValues.map((item, itemIndex) => {
          if (itemIndex === index)
            return {
              ...item,
              owner: {
                ...item.owner,
                subOwners: item.owner.subOwners.filter(
                  (subOwner) => subOwner.id !== id
                ),
              },
            };
          return item;
        })
      );
    }
  };
  const handleDeleteDataModal = (object, mainUser, subUser, id, index) => {
    let obj = {
      object,
      mainUser,
      subUser,
      id,
      index,
    };
    setDeleteModalData(obj);
    setDeleteDataModal(true);
  };
  const handleDeleteData = () => {
    handleSetSelectedRow(deleteModalData.object, deleteModalData.mainUser);
    handleDeleteOwner(
      deleteModalData.subUser,
      deleteModalData.id,
      deleteModalData.index
    );
  };
  const totalCount = () => {
    let count = 0;

    summaryValues.forEach((item) => {
      if (item?.owner) {
        count += item.owner?.value ? +item.owner.value : 0;
      }
    });
    return count.toLocaleString("de-DE");
  };

  const handleRemoveFile = (obj) => {
    setFocusedDocument(obj);
    setDeleteDocumentModal(true);
  };
  const handleClosePreviewModal = () => {
    setPreviewDocument(false);
    setFocusedDocument("");
    setFileStream("");
  };
  const handleCloseDeleteModal = () => {
    setDeleteDocumentModal(false);
  };
  const handleViewFile = async (document) => {
    const { boaUserMediaFileId, originalFilename } = document;
    setFileName(originalFilename);
    const result = await getFile({
      userId: clientId,
      boaMediaId: boaUserMediaFileId,
    });
    if (result?.payLoad) {
      setFileStream(result.payLoad);
      setPreviewDocument(true);
      setFocusedDocument(document);
    }
  };
  const handleDeleteFile = async () => {
    const { boaUserMediaFileId } = focusedDocument;

    const result = await deleteUserMediaBOA(clientId, boaUserMediaFileId);
    if (result?.success) {
      handleCloseDeleteModal();
      handleClosePreviewModal();
      dispatch(handleReloadFiles());
    }
  };
  const handleDeleteModalShow = () => setDeleteDocumentModal(true);

  return (
    <React.Fragment>
      <Toaster />
      {showSubOwnersModal && (
        <AddOwner
          open={showSubOwnersModal}
          handleOpen={handleSubOwnersModalOpen}
          handleClose={handleSubOwnersModalClose}
          handleDelete={() => {}}
          handleSubmit={handleAddOwner}
          type={selectedRow && selectedRow.type}
          id={selectedRow && selectedRow.id}
          selectedRow={selectedRow ? selectedRow : null}
          getInitialValues={getInitialValues}
          enteries={coShareHoldings(t)}
          validationSchema={validationSchema(t)}
          user={userName}
          companyName={selectedRow.companyName}
          tabName={t(getKeyFromText("Corporate Shareholdings"))}
        />
      )}
      <DeleteDataModal
        open={deleteDataModal}
        handleClose={() => {
          setDeleteDataModal(false);
        }}
        handleDelete={handleDeleteData}
        newFlow={true}
        user={userName}
      />
      <Box className="corporate-shareholding-container">
        <Box className="table-n-btns-wrapper">
          <Box
            className="upload-add-btn-wrapper"
            component="div"
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <SecondaryButton
              title={
                <>
                  <Typography
                    sx={{
                      fontWeight: 900,
                      fontSize: "1.5rem",
                      position: "absolute",
                      left: "7%",
                    }}
                  >
                    +
                  </Typography>
                  {t("add-line")}
                </>
              }
              textTransform="initial"
              fontWeight="normal"
              bgColor="color.magentaLight2"
              borderRadius="40px"
              padding="2px auto"
              minWidth="235px"
              border="none"
              marginLeft="20px"
              hoverBgColor="color.magentaLight1"
              click={() => {
                setInitialValues(null);
                setShowSubOwnersModal(true);
                setSelectedRow({ type: "owner", behaviour: "create" });
                setUserName("Corporate Shareholdings");
              }}
            />
            <ImportData
              sectionId={7}
              documentList={documentList}
              handleRemoveFile={handleRemoveFile}
              handleViewFile={handleViewFile}
            />
          </Box>
          <TableContainer component={Paper} className="summary-table">
            <Table
              sx={{
                "th , td": { border: "none" },
              }}
              stickyHeader
              aria-label="sticky table"
            >
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    {t("common-table-heading-7")}{" "}
                  </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-1")}
                  </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-2")}
                  </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-8")}
                  </TableCell>
                  <TableCell align="left">
                    {t("common-table-heading-9")}
                  </TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {summaryValues.map((item, index) => (
                  <>
                    <TableRow
                      sx={{
                        backgroundColor: `${
                          index % 2 === 0 ? "color.smokeWhite" : "color.white"
                        }`,
                      }}
                      className={
                        updatedIds.includes(item.id)
                          ? "highlighted-table-row"
                          : ""
                      }
                    >
                      <TableCell>
                        {item?.nameOfOwner ? item.nameOfOwner : "-"}
                      </TableCell>
                      <TableCell>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          {item?.owner?.nameOfOwner ? (
                            <>
                              {item.owner.nameOfOwner}{" "}
                              {
                                <IconButton
                                  sx={{
                                    cursor: "pointer",
                                  }}
                                  aria-label="Add"
                                  size="small"
                                  onClick={() => {
                                    setInitialValues({
                                      companyName: item.nameOfOwner,
                                      nameOfOwner: "",
                                      ownerShipPercentage: "",
                                      value: "",
                                      information: "",
                                    });
                                    handleSubOwnersModalOpen();
                                    setUserName("Corporate Shareholdings");
                                    handleSetSelectedRow(item, "subOwner");
                                  }}
                                >
                                  <AddCircleOutlineSharpIcon />
                                </IconButton>
                              }
                            </>
                          ) : (
                            "-"
                          )}
                        </Box>
                      </TableCell>
                      <TableCell>
                        {item?.owner?.ownerShipPercentage
                          ? item.owner.ownerShipPercentage + "%"
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {item?.owner?.value
                          ? Number(item.owner.value).toLocaleString("de-DE") +
                            " €"
                          : "-"}
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{
                            margin: 0,
                          }}
                          title={item.owner?.information}
                        >
                          {item?.owner?.information
                            ? item?.owner.information.slice(0, 10) + "..."
                            : "-"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        {
                          <>
                            <IconButton
                              sx={{ cursor: "pointer" }}
                              aria-label="add"
                              size="small"
                              onClick={() => {
                                handleSetSelectedRow(item, "owner", "edit");
                                setInitialValues({
                                  companyName: item.nameOfOwner,
                                  ...item.owner,
                                });
                                setUserName(item.owner.nameOfOwner);
                                handleSubOwnersModalOpen();
                              }}
                            >
                              <img
                                src="/assets/icons/edit-icon.svg"
                                alt="edit"
                              />
                            </IconButton>
                            <IconButton
                              sx={{ cursor: "pointer" }}
                              aria-label="delete"
                              size="small"
                              onClick={() => {
                                handleDeleteDataModal(
                                  item,
                                  "owner",
                                  "owner",
                                  item.id,
                                  index
                                );
                                setUserName(item.nameOfOwner);
                              }}
                            >
                              <img
                                src="/assets/icons/delete-icon.svg"
                                alt="delete"
                              />
                            </IconButton>
                          </>
                        }
                      </TableCell>
                    </TableRow>
                    {item?.owner?.subOwners?.length > 0 &&
                      item.owner.subOwners.map((owner, ownerIndex) => {
                        return (
                          <TableRow
                            key={owner?.id}
                            sx={{
                              backgroundColor: `${
                                index % 2 === 0
                                  ? "color.smokeWhite"
                                  : "color.white"
                              }`,
                            }}
                            className={
                              updatedIds.includes(owner.id)
                                ? "highlighted-table-row"
                                : ""
                            }
                          >
                            <TableCell></TableCell>
                            <TableCell>{owner.nameOfOwner}</TableCell>
                            <TableCell>
                              {owner.ownerShipPercentage + "%"}
                            </TableCell>
                            <TableCell>
                              {Number(owner.value).toLocaleString("de-DE") +
                                " €"}
                            </TableCell>
                            <TableCell>
                              <Typography
                                style={{
                                  margin: 0,
                                }}
                                title={owner?.information}
                              >
                                {owner?.information
                                  ? owner.information.slice(0, 10) + "..."
                                  : "-"}
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <IconButton
                                sx={{ cursor: "pointer" }}
                                aria-label="add"
                                size="small"
                                onClick={() => {
                                  handleSetSelectedRow(
                                    item,
                                    "subOwner",
                                    "edit"
                                  );
                                  setInitialValues({
                                    companyName: item.nameOfOwner,
                                    ...owner,
                                  });
                                  setUserName(owner.nameOfOwner);
                                  handleSubOwnersModalOpen();
                                }}
                              >
                                <img
                                  src="/assets/icons/edit-icon.svg"
                                  alt="edit"
                                />
                              </IconButton>

                              <IconButton
                                sx={{ cursor: "pointer" }}
                                aria-label="delete"
                                size="small"
                                onClick={() => {
                                  handleDeleteDataModal(
                                    item,
                                    "owner",
                                    "subOwner",
                                    owner.id,
                                    index
                                  );
                                  setUserName(item.nameOfOwner);
                                }}
                              >
                                <img
                                  src="/assets/icons/delete-icon.svg"
                                  alt="delete"
                                />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </>
                ))}

                <TableRow sx={{ background: "#dfc8db" }}>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell align="right">{t("total")}</TableCell>
                  <TableCell
                    sx={{ paddingLeft: "16px !important" }}
                  >{`${totalCount()} € `}</TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <SecondaryButton
            title={t("save-and-continue")}
            bgColor="color.magentaLight2"
            borderRadius="14px"
            width="200px"
            marginLeft="20px"
            border="none"
            hoverBgColor="color.magentaLight1"
            click={handleMainSubmit}
            textTransform="initial"
            disabled={btnLoading}
          />
        </Box>
      </Box>
      {updatesList?.length > 0 && (
        <ModifiedByToaster
          title={`${t("modified-by")} ${updatesList[0]?.username}` || ""}
          subTitle={` ${changeUpdateFormat(
            updatesList[0]?.updatedTime,
            i18n.language
          )}`}
        />
      )}
      {previewDocument && (
        <FilePreviewModal
          data={fileStream}
          handleClose={handleClosePreviewModal}
          handleDelete={handleDeleteModalShow}
          fileName={fileName}
        />
      )}
      {deleteDocumentModal && (
        <DeleteFileModal
          show={deleteDocumentModal}
          document={focusedDocument}
          handleClose={handleCloseDeleteModal}
          handleDelete={handleDeleteFile}
        />
      )}
    </React.Fragment>
  );
};

export default Summary;
